import { useNavigate, useLocation } from 'react-router-dom';

export default function useChatsNavigator() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const getChatsLink = () => '/chats';

  const getChatLink = (chatId: number) => `/chats/${chatId}`;

  const openChats = () => navigate(getChatsLink());

  const openChat = (chatId: number) => navigate(getChatLink(chatId));

  const isChatsPage = () => pathname.startsWith('/chats');

  return {
    getChatsLink,
    getChatLink,
    openChats,
    openChat,
    isChatsPage,
  };
}
